export const serviceTypes = [
  "Loose Cargo Load (LCL)",
  "Full Container Load (FCL)",
  "Rolling Cargo",
  "Heavy Equipment Loading",
  "Direct Loading",
  "General Cargo",
  "Lipat Bahay",
  "Customs Brokerage & Tariff Consultation",
  "Customs Clearance Processing"
];

export const travelModes = [
  "Air",
  "Land",
  "Sea"
];

export const deliveryTypes = [
  "Same Day",
  "Next Day"
];

export const shipmentStatuses = [
  "Order Created",
  "Cargo Picked Up",
  "In Transit",
  "Arrived at Destination Hub",
  "Out for Delivery",
  "Delivered"
];

export const statusColors = {
  "Order Created": "bg-blue-100 text-blue-800",
  "Cargo Picked Up": "bg-yellow-100 text-yellow-800",
  "In Transit": "bg-purple-100 text-purple-800",
  "Arrived at Destination Hub": "bg-indigo-100 text-indigo-800",
  "Out for Delivery": "bg-orange-100 text-orange-800",
  "Delivered": "bg-green-100 text-green-800"
};
